/* Keep the below-the-fold reviews app inert until the visitor approaches it. */
(() => {
  const templates = document.querySelectorAll('template[data-hc-lazy-reviews]');
  if (!templates.length) return;
  const activate = async template => {
    if (!template.isConnected || template.dataset.loading) return;
    template.dataset.loading = 'true';
    const fragment = template.content.cloneNode(true);
    const scripts = [...fragment.querySelectorAll('script')];
    // Insert markup/styles first; replay scripts in document order, after dependencies.
    const placeholders = scripts.map(script => {
      const marker = document.createComment('reviews script');
      script.replaceWith(marker);
      return marker;
    });
    template.replaceWith(fragment);
    for (let i = 0; i < scripts.length; i++) {
      if (!placeholders[i].isConnected) return;
      const original = scripts[i];
      const script = document.createElement('script');
      for (const attr of original.attributes) script.setAttribute(attr.name, attr.value);
      script.textContent = original.textContent;
      if (original.src) {
        script.async = false;
        await new Promise(resolve => {
          script.addEventListener('load', resolve, { once: true });
          script.addEventListener('error', resolve, { once: true });
          placeholders[i].replaceWith(script);
        });
      } else placeholders[i].replaceWith(script);
    }
  };
  if (!('IntersectionObserver' in window)) {
    templates.forEach(activate);
    return;
  }
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) {
      observer.unobserve(entry.target);
      entry.target.querySelectorAll('template[data-hc-lazy-reviews]').forEach(activate);
    }
  }, { rootMargin: '600px 0px' });
  templates.forEach(template => observer.observe(template.parentElement));
})();
